"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TOPICS_HASH = void 0;
exports.GET_TOPICS_HASH = `
  {
    topics
  }
`;
//# sourceMappingURL=topics-queries.js.map